import React, {useEffect, useState} from 'react'
import axios from 'axios'

import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'

import moment from 'moment';

//import {getSearchInterments} from '../../actions/interment-actions'

export default function SearchServiceRecords({searchString}) {
  const [formValues, setFormValues] = useState({
    firstName: '',
    lastName: '',
    section: '',
    lot: ''
  });
  const [serviceRecordList, setServiceRecordList] = useState([])
  const [filterBusy, setFilterBusy] = useState(false)
  const [filter, setFilter] = useState({firstName: '',lastName: '',section: '',lot: ''})

  useEffect(() => {

    const fetchData = async () => {
      setFilterBusy(true);
      const data = await getServiceRecords(filter.firstName, filter.lastName, filter.section, filter.lot)
      setServiceRecordList(data);
      setFilterBusy(false);
    }

    fetchData()

  }, [filter]);

  const performSearch = () => {
    setFilter(formValues)
  }

  const onFilterClick = (e) => {
    e.preventDefault();
    
    performSearch();
  }

  const onResetClick = (e) => {
    e.preventDefault();
    
    resetFormValues();

  }

  const handleFilterInputChange = (event) => {
    event.persist();
    //console.log(event.target.id)
    setFormValues((formValues) => ({
      ...formValues,
      [event.target.id]: event.target.value,
    }));
  };

  const resetFormValues = () => {
    setFormValues((formValues) => ({firstName: '',lastName: '',section: '',lot: ''}));

    setFilter({firstName: '',lastName: '',section: '',lot: ''});
  }


  const getServiceMetrics = async () => {
    const url = `/Interment/Metrics`;
    //console.log(data)
    const result = await axios.get(url)
    //console.log(result.data)
    
    return result.data
  }

  const getServiceRecords = async (firstName,lastName,section,lot) => {
    const url = `/Interment/Search`;

    if(
      (firstName === undefined || firstName === null || firstName === '')
      && (lastName === undefined || lastName === null || lastName === '')
     ) {
      return []
    }

    const data = {
      firstName: firstName?.toUpperCase() || '',
      lastName: lastName?.toUpperCase() || '',
      section: section?.toUpperCase() || '',
      lot: lot?.toUpperCase() || ''
    }
    //console.log(data)
    const result = await axios.post(url, data)
    //console.log(result.data)
    
    return result.data
  }
    function formatIntermentDateTemplate(rowData, column) {
        if(rowData.ActualServiceDate === undefined || rowData.ActualServiceDate === null || rowData.ActualServiceDate === '') {
            return null;
        }
      var dt = moment(new Date(rowData.ActualServiceDate));
      return `${ dt.format('L') }`;
    }

    return (
        <>
          <div className="card">
            <h5>Forest Hills Search</h5>
          </div>                  
          <div className="card">
            <div className="row mt-2">
              <div className="col-md-2">
                First Name:
              </div>
              <div className="col-md-2">
                <InputText
                  id="firstName"
                  value={formValues.firstName}
                  className="form-control"
                  placeholder="First Name..."
                  onChange={handleFilterInputChange}
                />
              </div>
              <div className="col-md-2">
                Last Name:
              </div>
              <div className="col-md-2">
                <InputText
                  id="lastName"
                  value={formValues.lastName}
                  className="form-control"
                  placeholder="Last Name..."
                  onChange={handleFilterInputChange}
                />
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-md-2">
                Section:
              </div>
              <div className="col-md-2">
                <InputText
                  id="section"
                  value={formValues.section}
                  className="form-control"
                  placeholder="Section..."
                  onChange={handleFilterInputChange}
                />
              </div>
              <div className="col-md-2">
                Lot:
              </div>
              <div className="col-md-2">
                <InputText
                  id="lot"
                  value={formValues.lot}
                  className="form-control"
                  placeholder="Lot..."
                  onChange={handleFilterInputChange}
                />
              </div>
            </div>

            <div className="row mt-2">
            <div className="col-md-2">
                <h5>Service Records {serviceRecordList.length ? '(' + serviceRecordList.length.toString() + ')' : '(0)'}</h5>
              </div>

              <div className="col-md-1 ml-1 mr-1">
                <Button
                  label="Search"
                  loading={filterBusy}
                  onClick={onFilterClick}
                  loadingIcon="pi pi-spin pi-sun" />
              </div>
              <div className="col-md-1 ml-1 mr-1">
                <Button
                  label="Reset"
                  loading={filterBusy}
                  onClick={onResetClick}
                  className="p-button-secondary"
                  loadingIcon="pi pi-spin pi-sun" />
              </div>
            </div>
            <hr />            
            <a href="#CemeteryMapsAnchor">Click here to download maps of the cemetery</a>
          </div>
          <div className="card">
            <DataTable
              value={serviceRecordList}
              responsiveLayout="scroll"
              dataKey="id"
              >
                <Column field="PIN" header="PIN" sortable />
                <Column field="LastName" header="Last Name" sortable />
                <Column field="FirstName" header="First Name" sortable />
                <Column field='ActualServiceDate' header="Service Date" sortable body={formatIntermentDateTemplate} />
                <Column field="ServiceType" header="Service Type" sortable />
                <Column field="Section" header="Section" sortable />
                <Column field="Lot" header="Lot" sortable />
                <Column field="GraveNumber" header="Grave" sortable />
            </DataTable>
          </div>
          <div className="card">
          <h3><a name="CemeteryMapsAnchor" href="!#">Cemetery Maps</a></h3>

<a target="_blank" href="./documents/cemetery_map_2018.pdf">Complete Cemetery Map</a><br />
<a target="_blank" href="./documents/SECTION%201.jpg">Section 1</a><br />
<a target="_blank" href="./documents/SECTION%202.jpg">Section 2</a><br />
<a target="_blank" href="./documents/SECTION%203.jpg">Section 3</a><br />
<a target="_blank" href="./documents/SECTION%20AL4.jpg">Section 4</a><br />
<a target="_blank" href="./documents/SECTION%205.jpg">Section 5</a><br />
<a target="_blank" href="./documents/SECTION%206.jpg">Section 6</a><br />



<a target="_blank" href="./documents/SECTION%2010.jpg">Section 10</a><br />

<a target="_blank" href="./documents/SECTION%2012.jpg">Section 12</a><br />

<a target="_blank" href="./documents/SECTION%2014.jpg">Section 14</a><br />
<a target="_blank" href="./documents/SECTION%2015.jpg">Section 15</a><br />
<a target="_blank" href="./documents/SECTION%2016.jpg">Section 16</a><br />

<a target="_blank" href="./documents/SECTION%2018.jpg">Section 18</a><br />
<a target="_blank" href="./documents/SECTION%2019.jpg">Section 19</a><br />
<a target="_blank" href="./documents/SECTION%2020.jpg">Section 20</a><br />
<a target="_blank" href="./documents/SECTION%2021.jpg">Section 21</a><br />
<a target="_blank" href="./documents/SECTION%2022.jpg">Section 22</a><br />
<a target="_blank" href="./documents/SECTION%20AL4.jpg">Section AL4</a><br />
<a target="_blank" href="./documents/SECTION%20C%20LOTS.jpg">Section C</a><br />
<a target="_blank" href="./documents/SECTION%20CH.jpg">Section CH</a><br />
<a target="_blank" href="./documents/SECTION%20D.jpg">Section D</a><br />
<a target="_blank" href="./documents/SECTION%20E.jpg">Section E</a><br />
<a target="_blank" href="./documents/SECTION%20FG.jpg">Section FG</a><br />
<a target="_blank" href="./documents/SECTION%20I.jpg">Section I</a><br />
<a target="_blank" href="./documents/SECTION%20J.jpg">Section J</a><br />
<a target="_blank" href="./documents/SECTION%20K.jpg">Section K</a><br />
<a target="_blank" href="./documents/SECTION%20M.jpg">Section M</a><br />
<a target="_blank" href="./documents/SECTION%20N.jpg">Section N</a><br />
<a target="_blank" href="./documents/SECTION%20P.jpg">Section P</a><br />
<a target="_blank" href="./documents/SECTION%20R.jpg">Section R</a><br />
<a target="_blank" href="./documents/SECTION%20S.jpg">Section S</a><br />
<a target="_blank" href="./documents/SECTION%20T.jpg">Section T</a><br />
<a target="_blank" href="./documents/SECTION%20W.jpg">Section W</a><br />
<a target="_blank" href="./documents/SECTION%20Y.jpg">Section Y</a><br />
          </div>
        </>
    )
}